import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgBsPlayFill({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 20 20"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				d="M15.495 10.8712L7.54125 15.4862C6.86625 15.8774 6 15.4037 6 14.6149V5.38495C6 4.59745 6.865 4.12245 7.54125 4.51495L15.495 9.12995C15.6485 9.2176 15.7762 9.3443 15.865 9.49721C15.9537 9.65011 16.0005 9.82377 16.0005 10.0006C16.0005 10.1774 15.9537 10.351 15.865 10.5039C15.7762 10.6568 15.6485 10.7835 15.495 10.8712Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgBsPlayFill;
